<template>
  <div class="calibration_container_all">
    <div class="mgx_top_right_fixed" v-if="calibrationHandler.state.initCalibrationStatus == true">
      <div class="top_right_btn mgx_action_btn ghost" @click="endCalibration">
        <span class="btn_text">{{ $t('end_key_calibration') }}</span>
      </div>
    </div>
    <div class="calibration_container all">
      <div class="calibration_key">
        {{
          t('calibration_tip', {
            count: kksList.length,
            total: Object.keys(kks).length,
          })
        }}
      </div>

      <div class="calibration_all_device">
        <Virtual_devices v-slot="slotProps">
          <div v-if="kksList.includes(slotProps.kk)" class="selected"></div>
        </Virtual_devices>
      </div>
      <div class="calibration_content">
        <div class="calibration_title" v-if="calibrationHandler.state.initCalibrationStatus == false">{{ $t('calibration_message_title') }}</div>
        <div class="calibration_des">{{ $t('calibration_notice_desc1') }}</div>
        <div class="calibration_des">{{ $t('calibration_notice_desc2') }}</div>
        <div class="calibration_des">{{ $t('calibration_notice_desc3') }}</div>
        <skip />
      </div>
    </div>
  </div>
</template>
<script lang="ts"></script>

<script setup lang="ts">
import { calibrationHandler } from '@/service/driver/calibration_set'
import { DriverService } from '@/service/driver/driver'
import { DriverSocketMsgType } from '@libs/types/message'
import { onMounted, onUnmounted, ref } from 'vue'
import i18n from '@/languages/i18n'
import { DevicePid, KK, kks } from '@/define/define'
import { DialogType, enableDialog } from '../cdialog/dialog'
import { delay } from '@libs/utils/tools'
import Skip from './skip.vue'
import Virtual_devices from '../device/virtual_devices.vue'
import { DeviceManager } from '@/service/device'
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector'

let { t } = i18n.global
const calibrating = ref(false)

onMounted(() => {
  setCalibrationEnabled(true)
  handlerCalibration()
})

onUnmounted(() => {
  if (DeviceManager.instance.state.currentPid === DevicePid.None) {
    handleEndCalibration()
  }
})
// 校准的kks
const kksList = ref<KK[]>([])
const endCalibration = async () => {
  await setCalibrationEnabled(false)
}

const handlerCalibration = () => {
  DriverService.instance.setHandler(DriverSocketMsgType.MSMagnetWatchCalibratin, (res: { [index: KK]: number }) => {
    kksList.value = []
    if (Object.keys(res).length == 0) {
      handleAutoEndAllKeyCalibration()
      return
    }
    for (const key in res) {
      if (res[key] > 0) {
        kksList.value.push(Number(key))
      }
    }
    if (calibrating.value && kksList.value.length != 0 && kksList.value.length == getCurrentDeviceMagnetKKs.value.length) {
      enableDialog(t('calculator_success'))
      handleEndCalibration()
    }
  })
}
const handleEndCalibration = async () => {
  await delay(300)
  await setCalibrationEnabled(false)
  if (calibrationHandler.state.initCalibrationStatus == false) {
    calibrationHandler.markCalibrationSuccess()
  }
}

// 自动结束按键校准
const handleAutoEndAllKeyCalibration = async () => {
  if (calibrationHandler.state.initCalibrationStatus == false) {
    initCalibrationConfirm()
    return
  }
  enableDialog(`${t('calibration_timer_error')}，${t('keyboard_calibration_finish_notice')}`, DialogType.notice, false, 2000)
  await setCalibrationEnabled(false)
  calibrationHandler.state.isShowCalibrationSelect = true
}

const initCalibrationConfirm = () => {
  enableDialog(t('all_calibration_err'), DialogType.restart).then(async (confirm: boolean) => {
    if (confirm) {
      setCalibrationEnabled(true)
    }
  })
}

// 开启或者关闭校准
const setCalibrationEnabled = async (enabled: boolean) => {
  calibrating.value = enabled
  await calibrationHandler.calibrationAllKeys(enabled)
  if (enabled == false) {
    calibrationHandler.state.isShowExeAllCalibration = false
  }
}
</script>

<style scoped lang="less">
.calibration_container_all {
  width: 100%;
  // background: #f2f2f2;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.all {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .calibration_key {
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: bold;
    height: 20px;
    color: #fff;
  }

  .calibration_all_device {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;

    :deep(.board_view) {
      transform: scale(1.2);
      transform-origin: center;
      background: var(--glass-ghost-bg);
      backdrop-filter: var(--glass-ghost-blur);
      border: 1px solid var(--glass-ghost-border);
      border-radius: var(--radius-l);
      padding: 20px;
    }

    :deep(.texture) {
      color: var(--color-dark) !important;
      font-weight: 700;
      opacity: 1 !important;
    }

    :deep(.selected) {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: var(--brand-color);
      border-radius: var(--radius-xs);
      box-shadow: 0 0 10px rgba(var(--color-brand-2-rgb), 0.3);
      transition: var(--transition-base);
      pointer-events: none;
    }
  }

  .calibration_content {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: center;
    color: #fff;

    .calibration_title {
      font-size: 20px;
      color: #fff;
      text-align: start;
      margin-bottom: 14px;
      font-weight: bold;
    }

    .calibration_des {
      font-size: 18px;
      line-height: 40px;
      text-align: start;
    }
  }
}
</style>
